export const EPSILON = 1e-12;
export const PI = Math.PI;
export const HALF_PI = PI / 2;
export const TAU = 2 * PI;
